import { Divider, Grid, Typography } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { GridRow, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import { getGPLUEligibilityBlockPropertyPaths } from '../PropertyPaths';

export const GPLUSpouseEligibilityBlock = () => {
  const { getQuoteFieldValue, updateQuoteFieldValue } = useQuoteField();
  const { selectedPlan, selectedCoverageIndex } = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUEligibilityBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: { key: 'row-413fa4bd-5525-4848-8e88-3800ca115ed4' },
      title: 'ISSUE AGES',
      items: [
        {
          key: propertyPaths.minIssueAge,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Issue Age"
              id={propertyPaths.minIssueAge}
              value={getQuoteFieldValue(propertyPaths.minIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minIssueAge, e.target.value)}
              type="number"
              disabled
              required
            />
          ),
        },
        {
          key: propertyPaths.maxIssueAge,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Issue Through Age"
              id={propertyPaths.maxIssueAge}
              value={getQuoteFieldValue(propertyPaths.maxIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.maxIssueAge, e.target.value)}
              type="number"
              disabled
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Eligibility" collapsible withSeparator>
      <Grid container alignItems="center" style={{ maxWidth: '100%' }}>
        {rows.map(
          ({ items, rowProps, title, hidden }, index) =>
            !hidden && (
              <React.Fragment key={rowProps?.key}>
                {title && (
                  <>
                    <Typography variant="body1" style={{ paddingLeft: '15px' }} className="lbl-main">
                      {title}
                    </Typography>
                    <Grid item xs={12}>
                      <Divider style={{ width: '100%', margin: '10px 0', color: '#2F3847' }} />
                    </Grid>
                  </>
                )}
                <GridRow items={items} rowProps={rowProps} />
              </React.Fragment>
            )
        )}
      </Grid>
    </FormWrapper>
  );
};
